import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Waves } from "lucide-react";
import { nwflPages } from "../data/nwfl";

// Permanent, timeless homepage callout for the Northwest Florida hurricane hub.
// No countdowns / forecast / panic language.
const HurricaneCallout = () => {
  return (
    <section className="bg-[#0A0A0A] border-y border-white/10 py-14" data-testid="home-hurricane-callout">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="bg-[#0F0F0F] border-l-4 border-[#E11D26] p-7 sm:p-10 flex flex-col lg:flex-row lg:items-center gap-8">
          <div className="flex-1">
            <div className="flex items-center gap-2 mb-3">
              <Waves className="h-4 w-4 text-[#E11D26]" />
              <span className="text-[#E11D26] text-xs font-bold tracking-[0.25em] uppercase">
                Northwest Florida · Emerald Coast
              </span>
            </div>
            <h2
              className="text-white text-2xl sm:text-3xl md:text-4xl font-black uppercase leading-tight"
              style={{ fontFamily: "'Anton','Oswald',sans-serif" }}
            >
              Hurricane Isaias Claim Help — Pensacola, Destin &amp; Northwest Florida
            </h2>
            <p className="mt-4 text-white/75 text-sm sm:text-base leading-relaxed max-w-3xl">
              Claim Beast assists Northwest Florida property owners with Hurricane
              Isaias-related wind, roof, water, flood, storm surge, denied, and underpaid
              insurance claims. Our licensed public adjusters document covered damage and
              review your carrier's estimate — no upfront cost.
            </p>
          </div>
          <div className="flex flex-col gap-3 shrink-0">
            <Link
              to="/hurricane-isaias-pensacola"
              data-testid="home-hurricane-pensacola"
              className="group inline-flex items-center justify-between gap-3 bg-[#E11D26] hover:bg-[#c11820] text-white font-bold uppercase tracking-wider px-6 py-4 transition-colors"
            >
              <span className="text-sm">Pensacola Claim Help</span>
              <ArrowRight className="h-5 w-5 transition-transform group-hover:translate-x-1" />
            </Link>
            {nwflPages["hurricane-isaias-destin"] && (
              <Link
                to="/hurricane-isaias-destin"
                data-testid="home-hurricane-destin"
                className="group inline-flex items-center justify-between gap-3 border border-white/20 hover:border-[#E11D26] text-white font-bold uppercase tracking-wider px-6 py-4 transition-colors"
              >
                <span className="text-sm">Destin Claim Help</span>
                <ArrowRight className="h-5 w-5 text-[#E11D26] transition-transform group-hover:translate-x-1" />
              </Link>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default HurricaneCallout;
